import { nsCustomization } from '@/app/i18n/namespaces';

const CUSTOMIZATION_STATUS = {
    NEW: { name: 'NEW', entity: 'status.NEW', namespace: nsCustomization, variant: 'blue' },
    PUBLISHED: { name: 'PUBLISHED', entity: 'status.PUBLISHED', namespace: nsCustomization, variant: 'green' },
    DRAFT: { name: 'DRAFT', entity: 'status.DRAFT', namespace: nsCustomization, variant: 'orange' }
};

export default CUSTOMIZATION_STATUS;